<!-- <div class="main-wrapper">
    <app-header></app-header>
    <div class="app-body position-relative">
        <app-sidebar></app-sidebar>
        <main class="main">
            <div class="row">
              <div class="col-md-12">
                <div class="divider-top">
                  <div class="card card-accent-primary">
                    <div class="card-header account-detail-head">Activity Log</div>
                    <div class="card-body account-stat-body">
                      <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <th>Login Date &amp; Time</th>
                                        <th>Login Status</th>
                                        <th>IP Address</th>
                                        <th>ISP</th>
                                        <th>City/State/Country</th>
                                    </thead>
                                    <tbody>
                                      
                                        <tr *ngFor="let onlineuser of onlineUserDetails;let i = index;">
                                            <td>{{(onlineuser?.login_time | date :'dd-MM-yyyy HH:mm:ss')}}</td>
                                            <td><span [ngClass]="{'text-danger':onlineuser?.login_status == 'login_failed','text-success':onlineuser?.login_status == 'login_success'}">{{onlineuser?.login_status}}</span></td>
                                            <td>{{onlineuser?.ip_address}}</td>
                                            <td>{{onlineuser?.geolocation?.isp}}</td>
                                            <td>{{onlineuser?.geolocation?.city}}/{{onlineuser?.geolocation?.state}}/{{onlineuser?.geolocation?.country}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </main>
        <div class="aside-menu d-none d-lg-block">
            <div class="card open-bet mb-0 border-0">
                <div class="card-header card-accrdn openbetlist">
                  <strong>Open Bets</strong>
                </div>
              </div>
            <div class="card open-bet mb-0 border-0">
                <div class="card-body open-bet-btns">
                  <div class="col-sm-12 p-0 mlist-openbets">
                    <select class="form-select" aria-label="Default select example"  [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch" (change)="openBet(searchMatch)">
                      <option selected>Select Market</option>
                      <option *ngFor="let match of MatchList;let i = index;" value="{{match}}"  ><span >{{match?.match_name}}</span></option>
                    </select>
                    <ng-select [ngModelOptions]="{standalone: true}" [(ngModel)]="searchMatch"
                                (change)="openBets(searchMatch)" class="form-select">
                                <ng-option *ngFor="let match of MatchList" [value]="match">{{match.match_name}}</ng-option>
                            </ng-select>
                  </div>                        
                </div>
                <div class="col-md-12 p-0">
                  <div class="bet_slip over-wrap racing-tab">
                    <div class="matchunmatch-tab tab-container">
                      <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                          <button class="nav-link active" id="matched1-tab" data-bs-toggle="tab" data-bs-target="#matched1-tab-pane" type="button" role="tab" aria-controls="matched1-tab-pane" aria-selected="true"><span>Matched</span></button>
                        </li>
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="unmatched1-tab" data-bs-toggle="tab" data-bs-target="#unmatched1-tab-pane" type="button" role="tab" aria-controls="unmatched1-tab-pane" aria-selected="false"><span>Unmatched</span></button>
                        </li>
                      </ul>
                      <div class="tab-content" id="myTabContent"  *ngIf="betList == true">
                        <div class="tab-pane fade show active" id="matched1-tab-pane" role="tabpanel" aria-labelledby="matched1-tab" tabindex="0">
                          <div class="slip-list">
                            <ul class="matched-head">
                              <li class="col-bet">Back (Bet For)</li>
                              <li class="col-odd">Odds</li>
                              <li class="col-stake">Stake</li>
                              <li class="col-profit">Profit</li>
                            </ul>
                            <dl *ngFor="let bet of backData;let i = index;" [ngClass]="{'slip-lay':bet.is_back == 0,'slip-back':bet.is_back == 1}">
                              <dt >
                                <span class="slip-type">{{bet.is_back == 0 ? 'Lay' : "Back"}} </span>
                                <span class="short-amount">{{bet?.selection_name}}</span>
                                <span id="marketName">{{bet?.market_name}}</span>
                              </dt>
                              <dd class="col-odd">{{bet?.odds}}</dd>
                              <dd class="col-stake">{{bet?.stack}}</dd>
                              <dd class="col-profit"><span>{{bet?.p_l | number : '0.0-2'}}</span></dd>
                            </dl>
                            <ul class="matched-head" >
                              <li class="col-bet">Lay (Bet Against)</li>
                              <li class="col-odd">Odds</li>
                              <li class="col-stake">Stake</li>
                              <li class="col-profit">Liability</li>
                            </ul>
                            <dl *ngFor="let bet of layData;let i = index;" [ngClass]="{'slip-lay':bet.is_back == 0,'slip-back':bet.is_back == 1}">
                              <dt>
                                <span class="slip-type">Lay</span>
                                <span class="short-amount">{{bet.is_fancy == 1 ?  (bet?.selection_name) : (bet?.market_name) }}</span>
                                <span id="marketName">{{bet.is_fancy == 0 ?  (bet?.market_name) : 'Fancy'}}</span>
                              </dt>
                              <dd class="col-odd">{{bet?.odds}}</dd>
                              <dd class="col-stake">{{bet?.stack}}</dd>
                              <dd class="col-profit"><span>{{bet?.liability | number : '0.0-2'}}</span></dd>
                            </dl>
                          </div>
                        </div>
                        <div class="tab-pane fade" id="unmatched1-tab-pane" role="tabpanel" aria-labelledby="unmatched1-tab" tabindex="0">

                        </div>
                      </div>                            
                    </div>
                  </div>
                </div>
              </div>
        </div>              
    </div>
    <app-footer-main></app-footer-main>
</div> -->

<div class="app-body">
  <app-header></app-header>
    <div class="full-wrap">
      <div class="col-left">
        <div class="sub_path">
          <div class="path">
            <a href="#path-pop" class="path-back">...</a>
            <ul>
              <li class="path-last"><a href="#">My Account</a></li>
            </ul>
          </div>
          <ul class="menu-list" data-widget="tree">
              <li>
                <a (click)="info()" class="select">
                  <span>My Profile</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="rollComission()">
                  <span>Rolling Commision</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="statement()">
                  <span>Account Statement</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a [routerLink]="['/betHistory']">
                  <span>Bets History</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="profitLoss()">
                  <span>Profit & Loss</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="history()">
                  <span>Password History</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="activity()">
                  <span>Activity Log</span><span class="pull-right-container"></span>
                </a>
              </li>
          </ul>
        </div>
      </div>

      <div id="centerColumn" class="col-center report">
        <!-- Loading Wrap -->
        <div id="loading" class="loading-wrap" style="top: 100px; display: none;">
            <ul class="loading">
                <li><img src="assets/sky_img/loading40.gif"></li>
                <li>Loading...
                </li>
                <br>
                <li><span id="progress"></span></li>
            </ul>
        </div>
        
        <h2>Activity Log</h2>
        <table class="table01">
          <tbody><tr>
            <th width="15%" class="align-L">Login Date &amp; Time</th>
            <th width="15%" class="align-L">Login Status</th>
            <th width="12%">IP Address</th>
            <th width="28%">ISP</th>
            <th width="">City/State/Country</th>
            <th width="">User Agent Type</th>
          </tr>
          </tbody>
          <tbody>
            <tr *ngFor="let onlineuser of onlineUserDetails;let i = index;">
              <td class="align-L">{{(onlineuser?.login_time | date :'dd-MM-yyyy HH:mm:ss')}}</td>
              <td class="align-L green"><span [ngClass]="{'text-danger':onlineuser?.login_status == 'login_failed','text-success':onlineuser?.login_status == 'login_success'}">{{onlineuser?.login_status}}</span></td>
              <td>{{onlineuser?.ip_address}}</td>
              <td>{{onlineuser?.geolocation?.isp}}</td>
              <td>{{onlineuser?.geolocation?.city}}/{{onlineuser?.geolocation?.state}}/{{onlineuser?.geolocation?.country}}</td>
              <td>Browser</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</div>

